import React, { useEffect, useState } from 'react'
import { api } from '../../../utils'
import LoadingSpinner from '../../atoms/Loading/Loading'
import { Altezza, Download, Info } from '../../atoms/NewIcons'
import _ from 'lodash'
import FormField from '../../atoms/FormField/FormField'
import FormFile from '../../atoms/FormFile/FormFile'
import Tooltip from '../../atoms/Tooltip/Tooltip'
import FormCheckbox from '../../atoms/FormCheckbox/FormCheckbox'
import useTrans from '../../../hooks/useTrans'
import * as Sentry from '@sentry/browser'
import { AnteprimaLogo } from '../../molecules'
import MyImage from '../../atoms/MyImage/MyImage'
import { Larghezza, Bin } from '../../atoms/NewIcons'
import { Goccia } from '../../atoms/NewIcons'
import FormTextarea from '../../atoms/FormTextarea/FormTextarea'
import { useMemo } from 'react'
import Upload from '../../atoms/NewIcons/Upload'
import { GocciaColor, GocciaSlash } from '@components/icons'

// isTracciaturaDefault comprende tutti i formati dove è possibile mostrare la checkbox per scegliere di inserire la tracciatura
// const isTracciaturaDefault = ['jpg', 'png', 'psd', 'jpeg', 'pdf']
// const visualizzaAnteprima = ['jpg', 'jpeg', 'png']

// Non mostriamo la checkbox per i formati vettoriali ('svg' e 'ai')
const isTracciaturaDisabled = ['svg+xml', 'postscript']
// Formati con checkbox NON preflaggata
const isTracciaturaNotPreflagged = ['pdf']

const getTipoFile = (filename) => {
  if (!filename) return null

  const extension = filename.split('.')?.[1]

  if (['svg'].includes(extension)) {
    return 'svg+xml'
  } else if (['ai', 'eps', 'ps'].includes(extension)) {
    return 'postscript'
  }

  return extension
}

const Posizione = ({ index, setFiles, files, item, articoliPreventivo, note, setNote }) => {
  const [tipoFile, setTipoFile] = useState(getTipoFile(item?.logo_filename))
  const [file, setFile] = useState(null)
  const [url, setUrl] = useState(item?.logo_file || null)
  const [urlName, setUrlName] = useState(item?.logo_filename || null)
  const t = useTrans()

  const updateTracciatura = (tracciatura) => {
    const new_files = files.map((file, i) => {
      if (i !== index) {
        return file
      }

      return {
        ...file,
        tracciatura: tracciatura,
      }
    })

    setFiles(new_files)
  }

  const updateFile = (file) => {
    setFile(file)

    let new_files = [...files]

    if (file === null) {
      // Rimuovere il file (file è null)
      new_files = new_files.filter((_, i) => i !== index)
    } else {
      const type = file.type.toString().toLowerCase().split('/')?.[1]
      setTipoFile(type)

      // Calcola la tracciatura
      let tracciatura = false
      if (!isTracciaturaDisabled.includes(type) && !isTracciaturaNotPreflagged.includes(type)) {
        tracciatura = true
      }

      new_files = [
        ...new_files.slice(0, index),
        new_files.at(index)
          ? {
              ...new_files[index],
              file: file,
              tracciatura: tracciatura,
            }
          : {
              file: file,
              tracciatura: tracciatura,
            },
        ...new_files.slice(index),
      ]
    }

    setFiles(new_files)
  }

  const reset = () => {
    updateFile(null)
    setUrl(null)
    setUrlName(null)
  }

  const _handleUpload = (e) => {
    const file = e.target.files[0] || null
    if (!file) return

    updateFile(file)
  }

  const personalizzazione = useMemo(() => {
    return item.numero_colori?.[0]?.personalizzazioni_objects?.[0] || item?.personalizzazione
  }, [item])

  const getAreaStampa = (personalizzazione) => {
    const getArticoloColore = (articolo) => {
      return (
        articolo?.attributi_lista?.find((attr) => attr.attributo_chiave === 'colore').id ||
        articolo?.colore?.id
      )
    }
    return articoliPreventivo
      ? personalizzazione?.aree_stampa?.find(
          (a) => a.colore?.id === getArticoloColore(articoliPreventivo?.[0])
        )
      : null
  }

  return (
    <div className="posizione">
      <div className="posizione__content">
        {getAreaStampa(personalizzazione)?.immagine?.url ? (
          <div className="posizione__imageBox">
            <MyImage
              className="posizione__image"
              src={getAreaStampa(personalizzazione).immagine.url}
              alt={t('Immagine articolo con area di stampa')}
              width={800}
              height={800}
              loading="eager"
            />
          </div>
        ) : (
          <div className="posizione__imageBox posizione__imageBox__icon">
            <Upload />
          </div>
        )}
        <div className="posizione__wrapper">
          <div className="posizione__header">
            <p className="posizione__title">{item.nome}</p>
          </div>
          <div className="configurazione-prodotto__posizioni__dimensione">
            <div className="uploadloghi__dimensione">
              <div className="configurazione-prodotto__posizioni__dimensione__item">
                <Altezza />
                {`${personalizzazione.dimensione_larghezza} cm`}
              </div>
              <div className="configurazione-prodotto__posizioni__dimensione__item ">
                <Larghezza />
                {`${personalizzazione.dimensione_larghezza} cm`}
              </div>
            </div>
          </div>

          <div className="tecnica__colore">
            <p className="tecnica__colori__row">
              <span
                className={`tecnica__colori__icon ${
                  !item.colori?.full_color ? 'tecnica__colori__icon__goccia' : ''
                }`}
              >
                {!item.colori?.full_color && item.colori?.numero_colori > 0 ? (
                  [...Array(item.colori?.numero_colori)].map((k, i) => (
                    <Goccia key={`upload-loghi-goccia-${i}`} />
                  ))
                ) : (
                  <span>
                    {item.colori?.codice === '000' ? (
                      <GocciaColor id={`upload-loghi-gocciacolor-${item.id}`} />
                    ) : (
                      <GocciaSlash />
                    )}
                  </span>
                )}
              </span>
              <span className="tecnica__colori__label">
                {item.colori?.nome}{' '}
                {item.colori?.full_color
                  ? ''
                  : item.colori?.numero_colori > 1
                  ? t('colori')
                  : t('colore')}
              </span>
            </p>
          </div>

          <div className="posizione__actions posizione__actions--desktop">
            {(file || url) && (
              <span className="formfile__icon" onClick={() => reset()}>
                {<Bin />}
              </span>
            )}
            {file ? (
              <a href={URL.createObjectURL(file)} target="_blank" className="posizione__download">
                <span className="formfile__icon">{<Download />}</span>
              </a>
            ) : url ? (
              <a href={url} target="_blank" className="posizione__download">
                <span className="formfile__icon">{<Download />}</span>
              </a>
            ) : (
              <></>
            )}
            <FormField>
              <FormFile
                placeholder={t('Carica logo')}
                name={index}
                filename={file?.name || urlName}
                onChange={_handleUpload}
                variant="button"
                icon={!(file || url) ? <Upload /> : null}
                key={file?.name || urlName}
              />
            </FormField>
          </div>

          <div className="posizione__descrizione">
            <FormTextarea
              name={'descrizione_' + index}
              value={note?.[index] || ''}
              onChange={(e) => {
                const newNotes = [...note]
                newNotes[index] = e.target.value
                setNote(newNotes)
              }}
              placeholder={t('Inserisci dettagli posizione')}
              label={t('Aggiungi note e dettagli sulla posizione')}
            />
          </div>

          {(file || url) && (
            <div className="posizione__imageBox__uploaded posizione__imageBox__uploaded--desktop">
              <AnteprimaLogo
                file={file}
                src={url}
                filename={file?.name || urlName || ''}
                className="posizione__anteprima-image"
                download={false}
              />
            </div>
          )}
        </div>
      </div>
      <div className="posizione__descrizione posizione__descrizione--mobile">
        <FormTextarea
          name={'descrizione_' + index}
          value={note?.[index] || ''}
          onChange={(e) => {
            const newNotes = [...note]
            newNotes[index] = e.target.value
            setNote(newNotes)
          }}
          placeholder={t('Inserisci dettagli posizione')}
          label={t('Aggiungi note e dettagli sulla posizione')}
        />
      </div>
      <div className="posizione__actions-wrapper posizione__actions-wrapper--mobile">
        <div className="posizione__actions posizione__actions--mobile">
          {(file || url) && (
            <span className="formfile__icon" onClick={() => reset()}>
              {<Bin />}
            </span>
          )}
          {file ? (
            <a href={URL.createObjectURL(file)} className="posizione__download" target="_blank">
              <span className="formfile__icon">{<Download />}</span>
            </a>
          ) : url ? (
            <a href={url} className="posizione__download" target="_blank">
              <span className="formfile__icon">{<Download />}</span>
            </a>
          ) : (
            <></>
          )}
          <FormField>
            <FormFile
              placeholder={t('Carica logo')}
              name={index}
              filename={file?.name || urlName}
              onChange={_handleUpload}
              variant="button"
              icon={!(file || url) ? <Upload /> : null}
              key={file?.name || urlName}
            />
          </FormField>
        </div>
        {(file || url) && (
          <div className="posizione__imageBox__uploaded posizione__imageBox__uploaded--mobile">
            <AnteprimaLogo
              file={file}
              src={url}
              filename={file?.name || urlName || ''}
              className="posizione__anteprima-image"
              download={false}
            />
          </div>
        )}
      </div>
      {(file || url) && (
        <div className="posizione__infologo">
          <div className="configurazione-prodotto-conferma__separator" />
          <div className={'posizione__footer'}>
            {!isTracciaturaDisabled.includes(tipoFile) && (
              <FormCheckbox
                label={t('Applica tracciatura logo')}
                checked={files[index]?.tracciatura}
                onChange={(e) => updateTracciatura(e.target.checked)}
              />
            )}
            <span className="posizione__avviso">
              *{t('Se il logo non è in vettoriale verrà addebitato il costo della lavorazione')}
            </span>
          </div>
        </div>
      )}
    </div>
  )
}

const UploadLoghi = ({
  note,
  setNote,
  posizioni,
  loghi,
  setLoghi,
  posizioniList,
  articoliPreventivo,
}) => {
  return (
    <div className="upload__loghi">
      <div className="upload__loghi__posizioni">
        {posizioni &&
          posizioni.map((posizione, index) => (
            <Posizione
              key={`posizione-${index}`}
              index={index}
              setFiles={setLoghi}
              files={loghi}
              item={posizioniList[index]}
              articoliPreventivo={articoliPreventivo}
              note={note}
              setNote={setNote}
            />
          ))}
      </div>
    </div>
  )
}

export default UploadLoghi


export const _uploadLoghiDimensioni = async ({
  id,
  file_to_upload,
  descrizione_posizione,
  setLoading,
  altezza,
  larghezza,
  pantoni_codici,
}) => {
  try {
    setLoading(true)
    if (file_to_upload.file) {
      let formData = new FormData()
      formData.append('file', file_to_upload.file)
      await api.put(`/posizione-personalizzazioni/${id}/logo_file/`, formData)
    }
    await api.put(`/posizione-personalizzazioni/${id}/`, {
      tracciatura_logo: file_to_upload.tracciatura,
      altezza: altezza,
      descrizione_posizione: descrizione_posizione,
      larghezza: larghezza,
      pantoni_codici: pantoni_codici,
    })
  } catch (error) {
    Sentry.captureException(error)
    throw error
  } finally {
    setLoading(false)
  }
}
